import jq from 'jquery';
import _ from 'ext:lodash';

export default {
	getNews(query){
		return new Promise((resolve, reject)=> {
			jq.getJSON('/bin/lt/news', query)
				.then((data)=> {
					//SUCCESS
					resolve(data);
				}, (xhr)=> {
					reject(xhr.status);
				});
		});
	}
};
